import { ExcelColumn } from "../../../../../../generic/hooks/useExportToExcel";
import { IDataQ4, IMetaDataQ4 } from "../../../../../../modules/API/Reports/models/q4";
import { formatNumber } from "../../shared/helpers/formatNumber";

export const calcPrice = (priceSum: number, weight: number) => {
  if (!priceSum || !weight) return ""
  return (priceSum / weight).toFixed(2)
}

export const buildQ4ExcelColumns = (
  metaData: IMetaDataQ4
): ExcelColumn<IDataQ4>[] => {
  const dynamicColumns: ExcelColumn<IDataQ4>[] = Object.entries(metaData)
    .filter(([, label]) => label.trim())
    .map(([key, label]) => ({
      header: label,
      accessor: (row: IDataQ4) => {
        const desc = row[`${key}_Desc` as keyof IDataQ4]
        return desc ? desc : row[key as keyof IDataQ4]
      },
    }))

  return [
    ...dynamicColumns,
    { header: 'אריזות', accessor: (row) => row.AmountPack },
    { header: 'משטחים', accessor: (row) => row.AmountPallets },
    { header: 'משקל', accessor: (row) => row.Weight.toLocaleString() },
    { header: 'מחיר', accessor: (row) => calcPrice(row.Price, row.Weight) },
    { header: 'פדיון', accessor: (row) => formatNumber(row.Price) },
  ]
}

export const filterData = (data: IDataQ4[], searchReport: string) => {
  const searchLower = searchReport.toLowerCase();
  return data.filter(item => 
    item.Field1_Desc?.trim().toLocaleLowerCase().includes(searchLower) ||
    item.Field2_Desc?.trim().toLocaleLowerCase().includes(searchLower)
  );
};
